import { render, staticRenderFns } from "./BookingView.vue?vue&type=template&id=837b9ff2&scoped=true&"
import script from "./BookingView.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BookingView.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BookingView.vue?vue&type=style&index=0&id=837b9ff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837b9ff2",
  null
  
)

export default component.exports